import { LinearProgress } from "@mui/material";

const ProgressBar = ({ percentage, color }) => {
  return (
    <div className="progress-container">
      <LinearProgress
        variant="determinate"
        value={percentage}
        aria-label="progress"
        color={color}
        sx={{
          borderRadius: "30rem",
        }}
      />
      <div>
        <small>Progress</small>
        <small>{percentage}%</small>
      </div>
    </div>
  );
};

export default ProgressBar;
